import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import StepperIcons from "./StepperIcons";
import { images } from "../../Images/Svg";
const {
  ActiveSaveIcon,
  DisabledSaveIcon,
  ActiveNextIcon,
  DisabledNextIcon,
  ActiveFinishIcon,
  DisabledFinishIcon,
} = images;

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      backgroundColor: "#14C15A",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      backgroundColor: "#14C15A",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 1,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#C8C8C8",
    borderRadius: 1,
  },
}));

function CustomStepper({
  stepperDetails = [],
  components = {},
  onSave = () => {},
  onFinish = () => {},
}) {
  const [activeStepper, setActiveStepper] = useState(null);
  const [isBtn1Active, setIsBtn1Active] = useState(false);
  const [isBtn2Active, setIsBtn2Active] = useState(false);
  const [saveClicked, setSaveClicked] = useState(false);
  const [nextClicked, setNextClicked] = useState(false);
  const [finishClicked, setFinishClicked] = useState(false);
  const isLastStepper =
    stepperDetails?.findIndex((obj) => obj?.label === activeStepper?.label) ==
    stepperDetails?.length - 1;
  const ActiveComponent = components?.[activeStepper?.component];

  const onSaveClick = () => {
    setSaveClicked(false);
    onSave();
  };

  const onNextClick = () => {
    let currentStepperIndex = stepperDetails?.findIndex(
      (obj) => obj?.label === activeStepper?.label
    );
    setNextClicked(false);
    setActiveStepper(stepperDetails[currentStepperIndex + 1]);
  };

  const onFinishClick = () => {
    setFinishClicked(false);
    onFinish();
  };

  const onStepperClick = (label) => {
    let currentStepperIndex = stepperDetails?.findIndex(
      (obj) => obj?.label === label
    );
    setActiveStepper(stepperDetails[currentStepperIndex]);
  };

  useEffect(() => {
    if (!activeStepper) setActiveStepper(stepperDetails?.[0]);
  }, []);

  return (
    <Box
      sx={{
        border: "1px solid #C8C8C8",
        borderRadius: "1rem",
        position: "relative",
        // marginTop: "3.5rem",
        // marginLeft: "2.5rem",
      }}
    >
      <Stack
        sx={{
          width: "100%",
          position: "absolute",
          top: "-23px",
          alignItems: "center",
        }}
        spacing={4}
      >
        <Stepper
          sx={{ width: "50%" }}
          alternativeLabel
          activeStep={stepperDetails?.findIndex(
            (obj) => obj?.label === activeStepper?.label
          )}
          connector={<ColorlibConnector />}
        >
          {stepperDetails?.map((obj) => (
            <Step key={obj?.label}>
              <StepLabel
                onClick={() => onStepperClick(obj?.label)}
                StepIconComponent={(obj) =>
                  StepperIcons({ ...obj, stepperDetails })
                }
              />
            </Step>
          ))}
        </Stepper>
      </Stack>
      <Box sx={{ width: "100%", minHeight: "60vh", padding: "20px" }}>
        <Box
          sx={{
            fontSize: "1.6rem",
            width: "fit-content",
            height: "2.9rem",
            padding: "5px 20px",
            borderRadius: "20px",
            background: "#0084FF",
            color: "#FFFFFF",
          }}
        >
          {activeStepper?.label}
        </Box>
        <Box sx={{ paddingTop: "2rem" }}>
          {ActiveComponent && (
            <ActiveComponent
              setIsBtn1Active={setIsBtn1Active}
              setIsBtn2Active={setIsBtn2Active}
              saveClicked={saveClicked}
              nextClicked={nextClicked}
              finishClicked={finishClicked}
              onSaveClick={onSaveClick}
              onFinishClick={onFinishClick}
              onNextClick={onNextClick}
            />
          )}
        </Box>
      </Box>

      <Box>
        <Box
          style={{ display: "flex", flexFlow: "row-reverse", padding: "10px" }}
        >
          {isBtn2Active ? (
            <img
              style={{ margin: "0 10px", cursor: "pointer" }}
              src={isLastStepper ? ActiveFinishIcon : ActiveNextIcon}
              alt="alternateIcon"
              onClick={() =>
                isLastStepper ? setFinishClicked(true) : setNextClicked(true)
              }
            />
          ) : (
            <img
              style={{ margin: "0 10px", cursor: "no-drop" }}
              src={isLastStepper ? DisabledFinishIcon : DisabledNextIcon}
              alt="alternateIcon"
            />
          )}
          {isBtn1Active ? (
            <img
              style={{ cursor: "pointer" }}
              src={ActiveSaveIcon}
              alt="alternateSaveIcon"
              onClick={() => setSaveClicked(true)}
            />
          ) : (
            <img
              style={{ cursor: "no-drop" }}
              src={DisabledSaveIcon}
              alt="alternateSaveIcon"
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default CustomStepper;
